"use strict";
// Copyright (c) StrangeBee 2023
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ParentController_1 = __importDefault(require("../ParentController"));
class ProfileController extends ParentController_1.default {
    constructor() {
        super(...arguments);
        this.endpoints = {
            create: '/v1/profile',
            edit: '/v1/profile/:objectId',
            delete: '/v1/profile/:objectId',
            getPermissions: '/v1/permission',
        };
    }
    getPermissions() {
        return this.manager.get({
            url: this.endpoints.getPermissions,
        });
    }
}
exports.default = ProfileController;
